import {
  Client,
  ExchangeBookingAnonymousTokenCommand,
  ExchangeMultibookingAnonymousTokenCommand,
} from "@repo/rq-api-public";

export async function exchangeBookingAnonymousToken(
  anonymousToken: string
): Promise<string | null | undefined> {
  try {
    const response =
      await Client.authenticationUserExchangeBookingAnonymousTokenPOST(
        new ExchangeBookingAnonymousTokenCommand({ anonymousToken })
      );
    return response.accessToken;
  } catch {
    try {
      const response =
        await Client.authenticationUserExchangeMultibookingAnonymousTokenPOST(
          new ExchangeMultibookingAnonymousTokenCommand({ anonymousToken })
        );
      return response.accessToken;
    } catch {
      return null;
    }
  }
}
